export default {
  en: {
    pricing: "Pricing",
    monthly: "Monthly",
    annual: "Annual",
    record: "record",
    month:"month",
    year:"year",
    signupforfree:"Sign up for free!",
    messages: {
      noAdminPermissions: "You do not have administration permissions for this account",
      contactAdmin: "Please contact the administration account owner for assistance.",
      loading: "Loading...",
      startFree: "Start for free",
      getStartedFree: "Get started for free with our generous plan, perfect for hobbyists and those exploring our services. Enjoy up to 1,000 records per day, including both historical weather data and forecasts for any location worldwide—no cost, no commitment!",
      yourCurrentSubscriptions: "Your current subscriptions",
      freePlan: "Free mode enabled - Upgrade your service plan to enable higher data limits and more features.",
      addPaymentMethod: "Adding a payment method will convert this to the metered plan",
      cancelsOn: "Cancels on",
      renewsOn: "Renews on",
      directBilling: "This subscription is billed directly. Please contact your account representative or sales@visualcrossing.com.",
      contactSupportForScheduled: "Please contact Visual Crossing Support to modify scheduled subscriptions.",
      twoMonthsFree: "2 months free!",
      availablePrimarySubscriptions: "Available primary subscriptions",
      openingPaymentPage: "Opening the payment processing page...",
      scheduledsubcription: "Please contact Visual Crossing Support to modify scheduled subscriptions.",
      scheduledsubcriptions: "Scheduled subscriptions",
      starts: "Starts on ",
      ends: "Ends on ",
      newviolator:"New!",
      annualviolator:"2 months free!",
      availableprimarysubs: "Historical & Forecast Data Plans",
      availableprimaryllxsubs: "High Concurrency, Low Latency Weather Forecast Plans", 
      availableaddonsubs: "Data Addon Options",
      primarygoalheader: "What weather data do you need?",
      current: "Current",
      contactus: "Contact us",
      comingsoon: "Coming soon",
      inpreview: "In preview",
      flexible:"Flexible options",
      contactsupport: "Contact support",
      chooseplan: "Choose plan",
      details: "Read more",
      cancel: "Cancel",
      renews: "Renews: ",
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      noprimary: "Add Subscription to Continue",
      cancelling: "Cancelling",
      introllxsubs_prefix: "Timeline LLX Weather API",
      introllxsubs: "High concurrency, ultra low latency plans use the {0} and lightweight Flat JSON or CSV to deliver real-time, hyperlocal weather forecasts and recent history data for mobile apps, IoT devices, and any use case requiring high volume forecast queries.  This API is currently in open beta and already available to all existing Visual Crossing Weather users. ",
      intoaddonsubs:"Data Addons allow your existing service plan to be enhanced with additional functionality.  The addon options below allow you to get more value from the data infrastructure that you already built and the weather solution that you trust.",
      primaryjump:"History & Forecast Data",
      llxjump:"Ultra Fast Forecast API",
      addjump:"Data Addons",
      industrydatajump:"Industry Data",
      showAllFeatures:"Show more features",
      showLess:"Show less",
      requesttrial:"Request trial",

    },
    
    descriptions: {
      meteredName: "Metered",
      metered: "The flexible weather data option for apps, teams, and periodic users.",
      corporateName: "Corporate",
      corporate: "For teams and small businesses who need to store and share weather data.",
      professionalName: "Professional",
      professional: "For individual users doing planning, data science, personal projects, and prototyping.",
      enterpriseName: "Enterprise",
      enterprise: "For business applications that demand high-availability and unlimited access.",
      histFcstName: "Historical Forecast",
      histFcst: "Weather forecasts created on historical dates.",
      weatherMaps:"Weather maps API for building interactive weather maps",
      weatherMapsName:"Weather Maps",
      weatherStats:"Detailed climate and weather statistics",
      weatherStatsName:"Weather Statistics",
      llxlevel1Name: "Timeline LLX Core",
      llxlevel1: "Ultra fast, high concurrency forecasts ideal for early stages apps and developers.",
      llxlevel2Name: "Timeline LLX Premium",
      llxlevel2: "Perfect for premium apps demanding large volumes of ultra fast forecasts.",
      llxEnterpriseName: "Timeline LLX Ultimate",
      llxEnterprise: "Leverage our proven weather data to exceed your most demanding needs.",
      loadingAccelerator:"Easily and quickly populate your datastores with high-quality weather data.",
      loadingAcceleratorName:"Loading Accelerator",
    },
    marketingFeatures:{
      unlimitedPerMo:"Unlimited records/month",
      singleConcurrency:"Single concurrency",
      unlimitedConcurrency:"Unlimited concurrency",
      customConcurrency:"Custom concurrency",
      teamConcurrency:"Team concurrency",
      tenMPerMo:"10,000,000 records/month",
      highconcurrency:"High concurrency",
      highcapacity:"High capacity",
      vhighcapacity:"Very high capacity",
      extremeconcurrency:"Extreme concurrency",
      extremecapacity: "Extreme capacity",
    },
    features: {
      history: "50 years history",
      forecast: "15-day forecast",
      conditions: "Current conditions",
      coverage: "Global coverage",
      api: "API & download",
      forum: "Forum support",
      geocoding: "Location geocoding",
      alerts: "Weather alerts",
      astronomy: "Astronomy data",
      unlimited: "Unlimited records/month.",
      team: "Team concurrency",
      email: "Email support",
      https: "HTTPS encryption",
      records: "10,000,000 records/month.",
      concurrency: "Single concurrency",
      bulkschedule:"Bulk & scheduler", 
      bulkonly:"Bulk",
      subhourly:"Sub-hourly data", 
      tenusers:"10 named users", 
      degreedays:"Degree days", 
      energyelements:"Energy elements", 
      agelements:"Agriculture elements", 
      marine:"Maritime wave & swell", 
      noattribution:"Attribution not required", 
      unlimitedusers:"Unlimited users", 
      sla:"SLA guarantee", 
      invoice:"Custom invoicing", 
      yearsavailable: "6-years' past forecasts",
      fullforecast: "Full 15-day forecast",
      customdays: "Choose forecast days",
      multiplelayers: "Multiple model layers",
      radarlayers: "Forecast radar layers",
      preciptotals: "Precipitation totals",
      easyintegrate: "Easy to integrate",
      historysummaries: "Historical summary",
      routefiltering: "Weather by route",
      frostdates: "Frost dates",
      customfiltering: "Threshold filtering",
      areaagg: "Aggregation by area",
      qpmlimitllx1: "5,000 API queries/minute",
      qpmolimitllx1: "50,000,000 queries/month",
      qpmlimitllx2: "40,000 API queries/minute",
      qpmolimitllx2: "200,000,000 queries/month",
      qpmlimitllxcontactus: "Unlimited queries/minute",
      qpmolimitllxcontactus: "Unlimited queries/month",
      forecast15days: "15-days forecast",
      hourlydays4: "4 days hourly data",
      minutelyhours3: "3 hours minutely data",
      hourlyupdates: "Hourly updates",
      geocoding: "Geocoding",
      structuredgeocoding: "Structured geocoding",
      integratedgeocoding: "Integrated geocoding",
      elements50: "Over 50 weather elements",
      limitedhistory: "Recent history",
      commercialuse: "Commercial use",
      uptime995: "99.5% Uptime",
      min10updates: "Real-time updates",
      realtimecurrent: "Real-time current conditions",
      recentHistory3: "Recent 3 years history",
      formatsflatjsoncsv: "Flat JSON, CSV",
      uptime999: "99.9% Uptime",
      populatefast: "Populate weather data fast!",
      loaddb: "Load databases & data lakes",
      increasedloadlimits: "Increased limits for ETL",
      unthrottled: "Guaranteed capacity",
      lengthflexible: "Pay only as long as needed",
      prioritysupport: "Priority Support",
      customterms: "Custom business terms",
      guaranteedcapacity: "Guaranteed capacity",
      extendedelements: "Energy, Agriculture, Maritime",
      integratedresult: "Single integrated result",
      weathermapapi: "Weather Map API",
    },
  },
  de: {
    pricing: "Kosten",
    monthly: "Monatlich",
    annual: "Jährlich",
    month: "Monat",
    year: "Jähr",
    record: "Datensatz",
    signupforfree: "Kostenlos anmelden!",
    messages: {
      noAdminPermissions: "Sie haben keine Administratorrechte für dieses Konto",
      contactAdmin: "Bitte wenden Sie sich an den Administrator, um Unterstützung zu erhalten.",
      loading: "Lädt...",
      startFree: "Kostenlos starten",
      getStartedFree: "Testen Sie unseren kostenlosen Zugang, ideal for Hobby und zum Evaluieren. Sie bekommen täglich 1000 Datensätze, inklusive historischer Daten und Wettervorhersagen weltweit. Keine Kosten, Keine Verpflichtungen! ",
      yourCurrentSubscriptions: "Ihre aktuellen Abonnements",
      freePlan: "Freier Modus aktiviert - Aktualisieren Sie Ihren Serviceplan, um höhere Datenlimits und mehr Funktionen freizuschalten.",
      addPaymentMethod: "Das Hinzufügen einer Zahlungsmethode wird diesen in den nutzungsabhängigen Plan umwandeln",
      cancelsOn: "Endet am",
      renewsOn: "Erneuert am",
      directBilling: "Dieses Abonnement wird direkt abgerechnet. Bitte wenden Sie sich an Ihren Vertriebsontakt oder an sales@visualcrossing.com.",
      contactSupportForScheduled: "Bitte wenden Sie sich an den Visual Crossing Support, um geplante Abonnements zu ändern.",
      twoMonthsFree: "2 Monate kostenlos!",
      availablePrimarySubscriptions: "Verfügbare primäre Abonnements",
      availableaddonsubs: "Verfügbare Zusatzabonnements",
      openingPaymentPage: "Öffnet die Zahlungsabwicklungsseite...",
      scheduledsubcription: "Bitte wenden Sie sich an den Visual Crossing Support, um geplante Abonnements zu ändern.",
      scheduledsubcriptions: "Geplante Abonnements",
      starts: "Beginnt am ",
      ends: "Endet am ",
      annualviolator: "2 Monate kostenlos!",
      availableprimarysubs: "Verfügbare primäre Abonnements",
      current: "Aktuell",
      contactus: "Kontakt",
      comingsoon: "Vorschau",
      inpreview: "Testbetrieb",
      contactsupport: "Support kontaktieren",
      chooseplan: "Plan auswählen",
      details: "Mehr erfahren",
      cancel: "Abbrechen",
      renews: "Erneuert: ",
      upgrade: "Upgrade",
      downgrade: "Downgrade",
      noprimary: "Kein primäres Abonnement",
      cancelling: "Wird gekündigt",
      newviolator: "Neu!",
      availableprimaryllxsubs: "Verfügbare LLX-Abonnements",
      primarygoalheader: "Welche Wetterdaten benötigen Sie?",
      flexible: "Flexible Optionen",
      introllxsubs_prefix: "Timeline LLX Wetter-API",
      introllxsubs: "Pläne mit hoher Gleichzeitigkeit und extrem niedriger Latenz nutzen die {0} sowie leichtgewichtiges JSON oder CSV, um Vorhersagen und jüngste Historie für Mobile-Apps, IoT-Geräte und mehr zu liefern. Der Dienst befindet sich in offener Beta und ist bereits für alle bestehenden Abonnenten verfügbar.",
      intoaddonsubs: "Daten-Add-ons erweitern Ihren bestehenden Plan um zusätzliche Funktionen, damit Sie noch mehr aus Ihrer vorhandenen Infrastruktur und Lösung herausholen.",
      primaryjump: "Historie & Vorhersage",
      llxjump: "Ultraschnelle Vorhersage-API",
      addjump: "Zusätzliche Add-ons",
      industrydatajump: "Branchendaten",
      showAllFeatures: "Mehr Funktionen anzeigen",
      showLess: "Weniger anzeigen",
      requesttrial: "Einladung anfordern"
    },
    descriptions: {
      meteredName: "Metered",
      metered: "Die flexible Wetterdatenoption für Apps, Teams und gelegentliche Nutzer.",
      corporateName: "Corporate",
      corporate: "Für Teams und kleine Unternehmen, die Wetterdaten gemeinsam nutzen.",
      professionalName: "Professional",
      professional: "Für Einzelbenutzer in Planung, Datascience, persönlichen Projekten oder Prototypen.",
      enterpriseName: "Enterprise",
      enterprise: "Für Anwendungen, die hohe Verfügbarkeit und unbegrenzten Zugriff erfordern.",
      histFcstName: "Historische Vorhersage",
      histFcst: "Wettervorhersagen, die zu vergangenen Zeitpunkten erstellt wurden.",
      weatherMaps: "Wetterkarten-API zum Erstellen interaktiver Wetterkarten",
      weatherMapsName: "Wetterkarten",
      weatherStats: "Detaillierte Klima- und Wetterstatistiken",
      weatherStatsName: "Wetterstatistiken",
      llxlevel1Name: "Timeline LLX Core",
      llxlevel1: "Ultraschnelle, hochgradig parallele Vorhersagen. Ideal für App-Entwicklung.",
      llxlevel2Name: "Timeline LLX Premium",
      llxlevel2: "Perfekt für Premium-Apps mit großen Mengen extrem schneller Vorhersagen.",
      llxEnterpriseName: "Timeline LLX Ultimate",
      llxEnterprise: "Nutzen Sie unsere bewährten Wetterdaten für Ihre anspruchsvollsten Anforderungen.",
      loadingAccelerator: "Befüllen Sie Ihre Datenspeicher schnell und einfach mit hochwertigen Wetterdaten.",
      loadingAcceleratorName: "Loading Accelerator"

    },
    marketingFeatures: {
      unlimitedPerMo: "Unbegrenzte Datensätze/Monat",
      singleConcurrency: "Einzelne Gleichzeitigkeit",
      unlimitedConcurrency: "Unbegrenzte Gleichzeitigkeit",
      customConcurrency: "Individuelle AGBs",
      teamConcurrency: "Team-Gleichzeitigkeit",
      tenMPerMo: "10.000.000 Datensätze/Monat",
      highconcurrency: "Hohe Gleichzeitigkeit",
      highcapacity: "Hohe Kapazität",
      vhighcapacity: "Sehr hohe Kapazität",
      extremeconcurrency: "Extrem hohe Gleichzeitigkeit",
      extremecapacity: "Extreme Kapazität"
    },
    features: {
      history: "50 Jahre Wetterhistorie",
      forecast: "15-Tage-Vorhersage",
      conditions: "Aktuelle Bedingungen",
      coverage: "Globale Abdeckung",
      api: "API & Download",
      forum: "Forum-Support",
      geocoding: "Standort-Geokodierung",
      alerts: "Wetterwarnungen",
      astronomy: "Astronomiedaten",
      unlimited: "Unbegrenzte Datensätze/Monat",
      team: "Team-Gleichzeitigkeit",
      email: "E-Mail-Support",
      https: "HTTPS-Verschlüsselung",
      records: "10.000.000 Datensätze/Monat",
      concurrency: "Einzel-Gleichzeitigkeit",
      bulkschedule: "Bulk & Terminierung",
      bulkonly:"Bulk",
      subhourly: "Minütliche Daten",
      tenusers: "10 individuelle Benutzer",
      degreedays: "Gradtage",
      energyelements: "Energie",
      agelements: "Landwirtschaft",
      marine: "Seegang & Wellenvorhersage",
      noattribution: "Keine Referenzierung",
      unlimitedusers: "Unbegrenzte Benutzer",
      sla: "SLA-Garantie",
      invoice: "Individuelle Rechnungsstellung",
      yearsavailable: "6 Jahre historische Vorhersagen",
      fullforecast: "Vollständige 15-Tage-Vorhersage",
      customdays: "Vorhersagetage anpassen",
      multiplelayers: "Mehrere Modell-Ebenen",
      radarlayers: "Vorhersage-Radarebenen",
      preciptotals: "Niederschlagssummen",
      easyintegrate: "Einfache Integration",
      historysummaries: "Historische Zusammenfassungen",
      routefiltering: "Wetter entlang der Route",
      frostdates: "Frostdaten",
      customfiltering: "Schwellenwert-Filterung",
      areaagg: "Aggregation nach Gebiet",
      forecast15days: "15-Tage-Vorhersage",
      qpmlimitllx1: "5.000 API-Anfragen/Minute",
      qpmolimitllx1: "50.000.000 Anfragen/Monat",
      qpmlimitllx2: "40.000 API-Anfragen/Minute",
      qpmolimitllx2: "200.000.000 Anfragen/Monat",
      qpmlimitllxcontactus: "Unbegrenzte Anfragen/Minute",
      qpmolimitllxcontactus: "Unbegrenzte Anfragen/Monat",
      hourlyupdates: "Stündliche Aktualisierung",
      formatsflatjsoncsv: "Flat JSON, CSV",
      populatefast: "Wetterdaten schnell befüllen",
      loaddb: "Datenbanken & Data Lakes befüllen",
      increasedloadlimits: "Erhöhte ETL-Grenzen",
      unthrottled: "Garantierte Kapazität",
      lengthflexible: "Nur so lange zahlen wie nötig",
      prioritysupport: "Priorisierter Support",
      customterms: "Individuelle Geschäftsbedingungen",
      guaranteedcapacity: "Garantierte Kapazität",
      extendedelements: "Energie, Landwirtschaft, Maritim",
      integratedresult: "Einzelnes integriertes Ergebnis",
      weathermapapi: "Wetterkarten-API",
      recentHistory3: "Jüngste 3 Jahre Historie",
      commercialuse: "kommerzielle Nutzung",
      hourlydays4: "4 Tage stündliche Daten",
      minutelyhours3: "3 Stunden minütliche Daten",
    },
  },

};
